export const diagramActionTypes = {
    CHANGE_THEME: 'D1',
    PRELOAD_STATE: 'D2',
    CHANGE_CURSOR: 'D3',
    HISTORY_UNDO: 'D4',
    HISTORY_REDO: 'D5',
    UPDATE_TABLE_COLUMN_NAME: 'D6',
    UPDATE_TABLE_COLUMN_TYPE: 'D7',
    UPDATE_TABLE_HEADER_NAME: 'D8',
    FOCUS_ON_COLUMN_BELOW: 'D9',
    FOCUS_ON_COLUMN_ABOVE: 'D10',
    FOCUS_ON_FIRST_COLUMN: 'D11',
    UPDATE_FOCUSED_GROUP: 'D12',
    UPDATE_FOCUSED_ELEMENTS: 'D13',
    UPDATE_FOCUSED_LINE: 'D14',
    UPDATE_FOCUSED_INSIDE_ELEMENT: 'D15',
    UPDATE_FOCUSED_AREA: 'D16',
    UPDATE_AREAS_POSITIONS: 'D17',
    UPDATE_ELEMENTS_POSITIONS: 'D18',
    UPDATE_LIVE_ELEMENTS_POSITIONS: 'D19',
    ADD_NEW_ELEMENT: 'D20',
    ADD_NEW_LINE: 'D21',
    ADD_NEW_AREA: 'D22',
    SET_NEW_AREA_ID_FOR_ELEMENT: 'D23',
    ADD_NEW_AREA_FOR_FOCUSED_ELEMENTS: 'D24',
    ADD_NEW_PEN_SEGMENT: 'D25',
    ENABLE_BTN_NEW_TABLE_CLICK: 'D26',
    DISABLE_BTN_NEW_TABLE_CLICK: 'D27',
    ENABLE_BTN_NEW_TABLE_GRAB: 'D28',
    DISABLE_BTN_NEW_TABLE_GRAB: 'D29',
    ENABLE_BTN_NEW_NOTE_CLICK: 'D30',
    DISABLE_BTN_NEW_NOTE_CLICK: 'D31',
    ENABLE_BTN_NEW_NOTE_GRAB: 'D32',
    DISABLE_BTN_NEW_NOTE_GRAB: 'D33',

    TOGGLE_BTN_NEW_LINE: 'D34',
    TOGGLE_BTN_NEW_AREA: 'D35',

    TOGGLE_BTN_PEN: 'D36',

    TOGGLE_BTN_EXPORT: 'D37',
    DISABLE_BTN_EXPORT: 'D38',
    TOGGLE_BTN_EXPORT_IMAGE: 'D39',
    DISABLE_BTN_EXPORT_IMAGE: 'D40',
    TOGGLE_BTN_EXPORT_CODE: 'D41',
    DISABLE_BTN_EXPORT_CODE: 'D42',

    TOGGLE_BTN_SETTINGS: 'D43',
    TOGGLE_BTN_MODAL_SHORTCUTS: 'D44',
    TOGGLE_BTN_PROFILE: 'D45',
    CANVAS_STARTED: 'D46',

    TOGGLE_BTN_SQL_SYNTAX: 'D47',
    SET_SQL_SYNTAX: 'D48',

    TOGGLE_BTN_VIEW_MODES: 'D49',
    DISABLE_BTN_VIEW_MODES: 'D50',

    TOGGLE_BTN_SEARCH: 'D51',
    TOGGLE_BTN_LEFT_PANEL: 'D52',
    TOGGLE_BTN_EDIT_NAME: 'D53',

    DISABLE_BTN_POPUP_NEWS: 'D54',

    TOGGLE_BTN_MINIMAP: 'D55',
    TOGGLE_BTN_INFO_RESOURCES: 'D56',

    SET_ELEMENTS_VIEW_MODE: 'D57',
    TOGGLE_BTN_RED_GREEN_VIEW: 'D58',
    DELETE_FOCUSED_AREA: 'D59',
    DUPLICATE_FOCUSED_AREA: 'D60',
    DELETE_ELEMENTS_BY_IDS: 'D61',
    DUPLICATE_ELEMENTS_BY_IDS: 'D62',
    DUPLICATE_COLUMN: 'D63',

    DELETE_FOCUSED_GROUP: 'D64',
    DUPLICATE_FOCUSED_GROUP: 'D65',


    AUTO_RESIZE_ELEMENTS_BY_IDS: 'D66',
    UPDATE_SCALE_PLUS: 'D67',
    UPDATE_SCALE_MINUS: 'D68',
    RESET_SCALE: 'D69',
    UPDATE_SCALE: 'D70',
    UPDATE_ORIGIN_XY: 'D71',
    UPDATE_SCALE_TO_FIT: 'D72',
    SET_ELEMENTS_BORDER: 'D73',
    SET_AREA_BORDER: 'D74',
    SET_ELEMENTS_COLOR: 'D75',

    SET_COLUMN_DESCRIPTION: 'D76',
    SET_ELEMENT_DESCRIPTION: 'D77',
    SET_AREA_DESCRIPTION: 'D78',
    SET_LINE_DESCRIPTION: 'D79',

    SET_COLUMN_KEY: 'D80',
    SET_COLUMN_INDEX: 'D81',
    SET_COLUMN_NOT_NULL: 'D82',
    SET_COLUMN_AUTO_INCREMENT: 'D83',

    SET_COLUMN_ENUM: 'D84',
    SET_COLUMN_DEFAULT_VALUE: 'D85',

    SET_COLUMN_GENERATED_VALUE: 'D86',
    SET_COLUMN_CHECK_VALUE: 'D87',

    DELETE_COLUMN: 'D88',
    MOVE_COLUMN_ABOVE: 'D89',
    MOVE_COLUMN_BELOW: 'D90',
    ADD_NEW_COLUMN_ABOVE: 'D91',
    ADD_NEW_COLUMN_BELOW: 'D92',
    ADD_NEW_FIRST_COLUMN: 'D93',
    ADD_NEW_COLUMN_IN_THE_END: 'D94',
    ADD_NEW_COLUMN_IN_THE_START: 'D95',
    SHOW_CONTEXT_MENU: 'D96',
    HIDE_CONTEXT_MENU: 'D97',
    TOGGLE_VISIBILITY_CONTEXT_MENU: 'D98',
    DELETE_LINE: 'D99',
    SET_LINE_CONNECTORS_REVERSED: 'D100',
    SET_LINE_CONNECTOR: 'D101',
    SET_LINE_SOLID_TYPE: 'D102',

    SET_LINE_ON_TRIGGER: 'D103',

    SET_LINE_COLOR: 'D104',
    SET_AREA_COLOR: 'D105',

    SET_NOTE_ALIGNMENT: 'D106',
    SET_NOTE_FONT_MONOSPACE: 'D107',
    SET_NOTE_FONT_STYLE: 'D108',

    CLICK_ESCAPE: 'D109',
    SET_IS_HISTORY_CLICKED: 'D110',

    SET_COLOR_NEW_PEN: 'D111',
    SET_WIDTH_NEW_PEN: 'D112',
    CLEAR_NEW_PEN: 'D113',

    ENABLE_ELEMENT_DESCRIPTION_EDITING: 'D114',
    DISABLE_ELEMENT_DESCRIPTION_EDITING: 'D115',

    FETCH_DIAGRAM_REQUEST: 'D116',
    FETCH_DIAGRAM_SUCCESS: 'D117',
    FETCH_DIAGRAM_FAILURE: 'D118',

    DISABLE_BTN_NEW_AREA: 'D119',

    ENABLE_CANVAS_MODAL_PRICING_PLAN_LIMIT: 'D120',
    DISABLE_CANVAS_MODAL_PRICING_PLAN_LIMIT: 'D121',

    ENABLE_CANVAS_MODAL_PRICING_PLAN_LIMIT_MAX: 'D122',
    DISABLE_CANVAS_MODAL_PRICING_PLAN_LIMIT_MAX: 'D123',

    LOAD_SAMPLE_PROJECT_DATA: 'D124',
    // LOAD_QUICK_SHARE_PROJECT_DATA: 'D125',

    TOGGLE_MODAL_DIAGRAM_EXPORT_SQL: 'D126',
    DISABLE_MODAL_DIAGRAM_EXPORT_SQL: 'D127',

    FOCUS_ALL_ELEMENTS: 'D128',

    ENABLE_BTN_EXPORT_IMAGE_CLICK: 'D129',
    DISABLE_BTN_EXPORT_IMAGE_CLICK: 'D130',

};




















// export const diagramActionTypes = {
//     CHANGE_THEME: 'CHANGE_THEME',
//     PRELOAD_STATE: 'PRELOAD_STATE',
//     CHANGE_CURSOR: 'CHANGE_CURSOR',
//     HISTORY_UNDO: 'HISTORY_UNDO',
//     HISTORY_REDO: 'HISTORY_REDO',
//     UPDATE_TABLE_COLUMN_NAME: 'UPDATE_TABLE_COLUMN_NAME',
//     UPDATE_TABLE_COLUMN_TYPE: 'UPDATE_TABLE_COLUMN_TYPE',
//     UPDATE_TABLE_HEADER_NAME: 'UPDATE_TABLE_HEADER_NAME',
//     FOCUS_ON_COLUMN_BELOW: 'FOCUS_ON_COLUMN_BELOW',
//     FOCUS_ON_COLUMN_ABOVE: 'FOCUS_ON_COLUMN_ABOVE',
//     FOCUS_ON_FIRST_COLUMN: 'FOCUS_ON_FIRST_COLUMN',
//     UPDATE_FOCUSED_GROUP: 'UPDATE_FOCUSED_GROUP',
//     UPDATE_FOCUSED_ELEMENTS: 'UPDATE_FOCUSED_ELEMENTS',
//     UPDATE_FOCUSED_LINE: 'UPDATE_FOCUSED_LINE',
//     UPDATE_FOCUSED_INSIDE_ELEMENT: 'UPDATE_FOCUSED_INSIDE_ELEMENT',
//     UPDATE_FOCUSED_AREA: 'UPDATE_FOCUSED_AREA',
//     UPDATE_AREAS_POSITIONS: 'UPDATE_AREAS_POSITIONS',
//     UPDATE_ELEMENTS_POSITIONS: 'UPDATE_ELEMENTS_POSITIONS',
//     UPDATE_LIVE_ELEMENTS_POSITIONS: 'UPDATE_LIVE_ELEMENTS_POSITIONS',
//     ADD_NEW_ELEMENT: 'ADD_NEW_ELEMENT',
//     ADD_NEW_LINE: 'ADD_NEW_LINE',
//     ADD_NEW_AREA: 'ADD_NEW_AREA',
//     SET_NEW_AREA_ID_FOR_ELEMENT: 'SET_NEW_AREA_ID_FOR_ELEMENT',
//     ADD_NEW_AREA_FOR_FOCUSED_ELEMENTS: 'ADD_NEW_AREA_FOR_FOCUSED_ELEMENTS',
//     ADD_NEW_PEN_SEGMENT: 'ADD_NEW_PEN_SEGMENT',
//     ENABLE_BTN_NEW_TABLE_CLICK: 'ENABLE_BTN_NEW_TABLE_CLICK',
//     DISABLE_BTN_NEW_TABLE_CLICK: 'DISABLE_BTN_NEW_TABLE_CLICK',
//     ENABLE_BTN_NEW_TABLE_GRAB: 'ENABLE_BTN_NEW_TABLE_GRAB',
//     DISABLE_BTN_NEW_TABLE_GRAB: 'DISABLE_BTN_NEW_TABLE_GRAB',
//     ENABLE_BTN_NEW_NOTE_CLICK: 'ENABLE_BTN_NEW_NOTE_CLICK',
//     DISABLE_BTN_NEW_NOTE_CLICK: 'DISABLE_BTN_NEW_NOTE_CLICK',
//     ENABLE_BTN_NEW_NOTE_GRAB: 'ENABLE_BTN_NEW_NOTE_GRAB',
//     DISABLE_BTN_NEW_NOTE_GRAB: 'DISABLE_BTN_NEW_NOTE_GRAB',

//     TOGGLE_BTN_NEW_LINE: 'TOGGLE_BTN_NEW_LINE',
//     TOGGLE_BTN_NEW_AREA: 'TOGGLE_BTN_NEW_AREA',

//     TOGGLE_BTN_PEN: 'TOGGLE_BTN_PEN',

//     TOGGLE_BTN_EXPORT: 'TOGGLE_BTN_EXPORT',
//     DISABLE_BTN_EXPORT: 'DISABLE_BTN_EXPORT',
//     TOGGLE_BTN_EXPORT_IMAGE: 'TOGGLE_BTN_EXPORT_IMAGE',
//     DISABLE_BTN_EXPORT_IMAGE: 'DISABLE_BTN_EXPORT_IMAGE',
//     TOGGLE_BTN_EXPORT_CODE: 'TOGGLE_BTN_EXPORT_CODE',
//     DISABLE_BTN_EXPORT_CODE: 'DISABLE_BTN_EXPORT_CODE',

//     TOGGLE_BTN_SETTINGS: 'TOGGLE_BTN_SETTINGS',
//     TOGGLE_BTN_MODAL_SHORTCUTS: 'TOGGLE_BTN_MODAL_SHORTCUTS',
//     TOGGLE_BTN_PROFILE: 'TOGGLE_BTN_PROFILE',
//     CANVAS_STARTED: 'CANVAS_STARTED',

//     TOGGLE_BTN_SQL_SYNTAX: 'TOGGLE_BTN_SQL_SYNTAX',
//     SET_SQL_SYNTAX: 'SET_SQL_SYNTAX',

//     TOGGLE_BTN_VIEW_MODES: 'TOGGLE_BTN_VIEW_MODES',
//     DISABLE_BTN_VIEW_MODES: 'DISABLE_BTN_VIEW_MODES',

//     TOGGLE_BTN_SEARCH: 'TOGGLE_BTN_SEARCH',
//     TOGGLE_BTN_LEFT_PANEL: 'TOGGLE_BTN_LEFT_PANEL',
//     TOGGLE_BTN_EDIT_NAME: 'TOGGLE_BTN_EDIT_NAME',

//     DISABLE_BTN_POPUP_NEWS: 'DISABLE_BTN_POPUP_NEWS',

//     TOGGLE_BTN_MINIMAP: 'TOGGLE_BTN_MINIMAP',
//     TOGGLE_BTN_INFO_RESOURCES: 'TOGGLE_BTN_INFO_RESOURCES',

//     SET_ELEMENTS_VIEW_MODE: 'SET_ELEMENTS_VIEW_MODE',
//     TOGGLE_BTN_RED_GREEN_VIEW: 'TOGGLE_BTN_RED_GREEN_VIEW',
//     DELETE_FOCUSED_AREA: 'DELETE_FOCUSED_AREA',
//     DUPLICATE_FOCUSED_AREA: 'DUPLICATE_FOCUSED_AREA',
//     DELETE_ELEMENTS_BY_IDS: 'DELETE_ELEMENTS_BY_IDS',
//     DUPLICATE_ELEMENTS_BY_IDS: 'DUPLICATE_ELEMENTS_BY_IDS',
//     DUPLICATE_COLUMN: 'DUPLICATE_COLUMN',

//     DELETE_FOCUSED_GROUP: 'DELETE_FOCUSED_GROUP',
//     DUPLICATE_FOCUSED_GROUP: 'DUPLICATE_FOCUSED_GROUP',


//     AUTO_RESIZE_ELEMENTS_BY_IDS: 'AUTO_RESIZE_ELEMENTS_BY_IDS',
//     UPDATE_SCALE_PLUS: 'UPDATE_SCALE_PLUS',
//     UPDATE_SCALE_MINUS: 'UPDATE_SCALE_MINUS',
//     RESET_SCALE: 'RESET_SCALE',
//     UPDATE_SCALE: 'UPDATE_SCALE',
//     UPDATE_ORIGIN_XY: 'UPDATE_ORIGIN_XY',
//     UPDATE_SCALE_TO_FIT: 'UPDATE_SCALE_TO_FIT',
//     SET_ELEMENTS_BORDER: 'SET_ELEMENTS_BORDER',
//     SET_AREA_BORDER: 'SET_AREA_BORDER',
//     SET_ELEMENTS_COLOR: 'SET_ELEMENTS_COLOR',

//     SET_COLUMN_DESCRIPTION: 'SET_COLUMN_DESCRIPTION',
//     SET_ELEMENT_DESCRIPTION: 'SET_ELEMENT_DESCRIPTION',
//     SET_AREA_DESCRIPTION: 'SET_AREA_DESCRIPTION',
//     SET_LINE_DESCRIPTION: 'SET_LINE_DESCRIPTION',

//     SET_COLUMN_KEY: 'SET_COLUMN_KEY',
//     SET_COLUMN_INDEX: 'SET_COLUMN_INDEX',
//     SET_COLUMN_NOT_NULL: 'SET_COLUMN_NOT_NULL',
//     SET_COLUMN_AUTO_INCREMENT: 'SET_COLUMN_AUTO_INCREMENT',

//     SET_COLUMN_ENUM: 'SET_COLUMN_ENUM',
//     SET_COLUMN_DEFAULT_VALUE: 'SET_COLUMN_DEFAULT_VALUE',

//     SET_COLUMN_GENERATED_VALUE: 'SET_COLUMN_GENERATED_VALUE',
//     SET_COLUMN_CHECK_VALUE: 'SET_COLUMN_CHECK_VALUE',

//     DELETE_COLUMN: 'DELETE_COLUMN',
//     MOVE_COLUMN_ABOVE: 'MOVE_COLUMN_ABOVE',
//     MOVE_COLUMN_BELOW: 'MOVE_COLUMN_BELOW',
//     ADD_NEW_COLUMN_ABOVE: 'ADD_NEW_COLUMN_ABOVE',
//     ADD_NEW_COLUMN_BELOW: 'ADD_NEW_COLUMN_BELOW',
//     ADD_NEW_FIRST_COLUMN: 'ADD_NEW_FIRST_COLUMN',
//     ADD_NEW_COLUMN_IN_THE_END: 'ADD_NEW_COLUMN_IN_THE_END',
//     ADD_NEW_COLUMN_IN_THE_START: 'ADD_NEW_COLUMN_IN_THE_START',
//     SHOW_CONTEXT_MENU: 'SHOW_CONTEXT_MENU',
//     HIDE_CONTEXT_MENU: 'HIDE_CONTEXT_MENU',
//     TOGGLE_VISIBILITY_CONTEXT_MENU: 'TOGGLE_VISIBILITY_CONTEXT_MENU',
//     DELETE_LINE: 'DELETE_LINE',
//     SET_LINE_CONNECTORS_REVERSED: 'SET_LINE_CONNECTORS_REVERSED',
//     SET_LINE_CONNECTOR: 'SET_LINE_CONNECTOR',
//     SET_LINE_SOLID_TYPE: 'SET_LINE_SOLID_TYPE',

//     SET_LINE_ON_TRIGGER: 'SET_LINE_ON_TRIGGER',

//     SET_LINE_COLOR: 'SET_LINE_COLOR',
//     SET_AREA_COLOR: 'SET_AREA_COLOR',

//     SET_NOTE_ALIGNMENT: 'SET_NOTE_ALIGNMENT',
//     SET_NOTE_FONT_MONOSPACE: 'SET_NOTE_FONT_MONOSPACE',
//     SET_NOTE_FONT_STYLE: 'SET_NOTE_FONT_STYLE',

//     CLICK_ESCAPE: 'CLICK_ESCAPE',
//     SET_IS_HISTORY_CLICKED: 'SET_IS_HISTORY_CLICKED',

//     SET_COLOR_NEW_PEN: 'SET_COLOR_NEW_PEN',
//     SET_WIDTH_NEW_PEN: 'SET_WIDTH_NEW_PEN',
//     CLEAR_NEW_PEN: 'CLEAR_NEW_PEN',

//     ENABLE_ELEMENT_DESCRIPTION_EDITING: 'ENABLE_ELEMENT_DESCRIPTION_EDITING',
//     DISABLE_ELEMENT_DESCRIPTION_EDITING: 'DISABLE_ELEMENT_DESCRIPTION_EDITING',

//     FETCH_DIAGRAM_REQUEST: 'FETCH_DIAGRAM_REQUEST',
//     FETCH_DIAGRAM_SUCCESS: 'FETCH_DIAGRAM_SUCCESS',
//     FETCH_DIAGRAM_FAILURE: 'FETCH_DIAGRAM_FAILURE',

//     DISABLE_BTN_NEW_AREA: 'DISABLE_BTN_NEW_AREA',

//     ENABLE_CANVAS_MODAL_PRICING_PLAN_LIMIT: 'ENABLE_CANVAS_MODAL_PRICING_PLAN_LIMIT',
//     DISABLE_CANVAS_MODAL_PRICING_PLAN_LIMIT: 'DISABLE_CANVAS_MODAL_PRICING_PLAN_LIMIT',


//     ENABLE_CANVAS_MODAL_PRICING_PLAN_LIMIT_MAX: 'ENABLE_CANVAS_MODAL_PRICING_PLAN_LIMIT_MAX',
//     DISABLE_CANVAS_MODAL_PRICING_PLAN_LIMIT_MAX: 'DISABLE_CANVAS_MODAL_PRICING_PLAN_LIMIT_MAX',

//     LOAD_SAMPLE_PROJECT_DATA: 'LOAD_SAMPLE_PROJECT_DATA',
//   //   LOAD_QUICK_SHARE_PROJECT_DATA: 'LOAD_QUICK_SHARE_PROJECT_DATA',

//    TOGGLE_MODAL_DIAGRAM_EXPORT_SQL: 'TOGGLE_MODAL_DIAGRAM_EXPORT_SQL',
//    DISABLE_MODAL_DIAGRAM_EXPORT_SQL: 'DISABLE_MODAL_DIAGRAM_EXPORT_SQL',

//    FOCUS_ALL_ELEMENTS: 'FOCUS_ALL_ELEMENTS',

//    ENABLE_BTN_EXPORT_IMAGE_CLICK: 'ENABLE_BTN_EXPORT_IMAGE_CLICK',
//    DISABLE_BTN_EXPORT_IMAGE_CLICK: 'DISABLE_BTN_EXPORT_IMAGE_CLICK',
// };
